<script setup lang="ts">

withDefaults(defineProps<{
    title: string,
    id: string,
    name?: string,
    modelValue: boolean,
}>(), {
    name: undefined,
});

defineEmits<{
    (on:"update:modelValue", value: boolean): void
}>();

const checkedValueFromEvent = (event: Event) : boolean => {
    return (<HTMLInputElement>event.target)?.checked ?? false;
};

</script>

<template>
    <div class="col-12 col-md-6 mt-2 position-relative">
        <input
            :id="id || name"
            class="checkbox align-middle"
            :name="name || id"
            type="checkbox"
            :checked="modelValue"
            @change="$emit('update:modelValue', checkedValueFromEvent($event))"
        >
        <label
            :for="id || name"
            class="order-first form-checkbox-label disable-selection align-middle show-pointer label-hover-fix"
        >
            {{ title }}
        </label>
    </div>
</template>

<style lang="scss">

</style>
